import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useRef, useState, useEffect } from 'react';
import apis from '../../api';
import '../../utils/react-dates-override.css';
import { Label, Input } from './Verification.styles';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Support
Description : Pantalla de solicitud de soporte por parte del cliente
Date Autor Modification
================================================================================
22/10/2021 Santiago Coca Rojas Creación – Se implementan la tabla y el formulario desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente de acuerdo a los cambios realizados con PrimeReact
================================================================================ */

export default function Verification() {

    const [codigo, setCodigo] = useState("")
    const [solicitado, setSolicitado] = useState(false)

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const headers = {
        authorization: localStorage.getItem('token')
    }

    const elementWidth = { width: "20rem" }
    const toast = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            setSolicitado(false)
        }, 120000)
    }, [solicitado])

    function validateForm() {
        return codigo !== ""
    }

    async function getVerification() {
        try {
            await apis.getVerificationCode(headers).then(res => {
                setLoading2(false)
                setSolicitado(true)
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Código enviado a su correo exitosamente. Por favor valide e ingreselo", sticky: true });
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: err.response.data.message, sticky: true });
        }
    }
    async function postVerification() {
        const _codigo = codigo

        const verification = {
            CODE: _codigo
        }

        try {
            await apis.postVerificationCode(verification, headers).then(res => {
                setLoading1(false)
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Verificación exitosa" });
                //setEnviado(true)
                setTimeout(() => {
                    window.location.replace("/CompanyInfo")
                }, 4000)
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: err.response.data.message, sticky: true });
        }
    }

    return (
        <div className='mt-6 pt-2'>
            <div className="surface-section w-10 m-auto  mt-6">
                <div class="grid">
                    <div className="col-12">
                        <div style={{ marginBottom: "2rem", marginTop: "4rem" }} className="mb-3 font-bold text-4xl">
                            <span className="text-900">Verificación de cuenta</span>
                        </div>
                        <Label style={{ fontSize: '18px', textAlign: "left", marginLeft: "2rem", width: "46rem", marginLeft: "12rem" }} htmlFor="label">
                            Su cuenta de Remuner aún no se encuenta verificada. Por favor solicite un código de verificación.
                            Dicho código llegará a su correo electrónico y deberá ingresarlo para verificar su cuenta (Si el código no llega,
                            podrá solicitarlo nuevamente dentro de 2 minutos).
                        </Label>
                    </div>
                    <Toast ref={toast} />
                    <div class="col-6 ml-8">
                        <div>
                            <Label htmlFor="label" style={{ marginLeft: "7rem", fontWeight: "bold", color: "#828282" }}>Código de verificación</Label>
                            <InputText
                                id="label"
                                type="number"
                                disabled={!solicitado}
                                style={{ marginTop: "-1rem", width: "20rem" }}
                                value={codigo}
                                onChange={(e) => { setCodigo(e.target.value) }}
                            />
                        </div>
                        <div style={{ marginTop: "2rem", marginLeft: "-4rem" }}>
                            <a style={{ textDecoration: 'none' }}>
                                <Button block label="Pedir código" loading={loading2} type="submit" disabled={solicitado}
                                    onClick={() => {
                                        setLoading2(true);
                                        getVerification();
                                    }} />
                            </a>
                            <a style={{ textDecoration: 'none', marginLeft: "1rem" }}>
                                <Button block label="Verificar" loading={loading1} type="submit" disabled={!validateForm()}
                                    onClick={() => {
                                        setLoading1(true);
                                        postVerification();
                                    }} />
                            </a>
                        </div>
                    </div>
                    <div class="col-5 -mt-8 -ml-8">
                        <img class="w-full" src={process.env.REAT_APP_EMAIL} alt="Hola"></img>
                    </div>
                </div>
            </div>
        </div >
    )
}